import styles from './Commande.module.css';
import "./Commande.css";
import React, { useEffect, useState } from 'react';
import { castDate, addressFormat } from '../../shared/utils/string';
import { useTranslation } from 'react-i18next';
import { Map } from './../google_map';
import { asTitle } from '../../shared/utils/string';
import i18nDisplay from '../../utils/i18nDisplay';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, Chip, MenuList, MenuItem, IconButton, ListItemText, ListItemIcon, Divider, createTheme, ThemeProvider, TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import FicheClientService from "../../services/fiche_client.service";
import FicheHotelService from "../../services/fiche_hotel.service";
import BookingService from "../../services/booking.service";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EditIcon from '@mui/icons-material/Edit';
import AdminFlexibleCancellationModal from '../AdminFlexibleCancellationModal';
import GeneralSettingService from '../../services/general_setting.service';
import CalendarManagementService from "../../services/calendar_management.service";
import PromotionService from "../../services/promotion.service";
import { pdf } from "@react-pdf/renderer";
import PDFFile from './../../components/PDFFile';
import { useNotifications } from '../../context/NotificationProvider';
import EditBookingModal from '../../components/BookingEditModal';
import CreateTaskModal from "./../CreateBookingModal";
import Modal from "react-modal";
import useAuth from '../../hooks/useAuth';


const theme = createTheme({
    palette: {
        white: {
            "main": "#FFFFFF",
            "light": "#FFFFFF",
            "dark": "#FFFFFF",
            "contrastText": "#FFFFFF"
        },
        dark_yellow: {
            "main": "#393D44",
            "light": "#393D44",
            "dark": "#393D44",
            "contrastText": "#FAEF9B",
        },
        dark_white: {
            "main": "#393D44",
            "light": "#393D44",
            "dark": "#393D44",
            "contrastText": "#FFFFFF",
        },
        dark: {
            "main": "#393D44",
            "light": "#393D44",
            "dark": "#393D44",
            "contrastText": "#393D44"
        }
    },
});
const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        overflow: "hidden auto",
        scrollbarWidth: "none",
        height: "650px",
    },
};

const PAYMENT_LINK_RESEND_STATUSES = new Set(['CREATED', 'PROCESSING_PAYMENT', 'FAILED_PAYMENT']);

function canResendPaymentLink(booking) {
    return Boolean(
        booking
        && !booking.offline_payment
        && PAYMENT_LINK_RESEND_STATUSES.has(booking.status)
    );
}


const Commande = ({ selectedItem, api, fetchBookings }) => {
    const [activeTab, setActiveTab] = useState('details');
    const { t, i18n } = useTranslation(['dashboard', 'bill']);
    const [mapState, setMapState] = useState({ lat: 46.2643, lng: 6.3166, zoom: 10 });
    const statusOrder = ['IN_TRANSIT', 'REACHED', 'STARTED', 'COMPLETED'];
    const currentStepIndex = statusOrder.indexOf(selectedItem.booking.status);
    const [promodetails, setPromodetails] = useState('');

    const isEnRouteFilled = currentStepIndex >= 0;
    const isPreparationFilled = currentStepIndex >= 1;
    const isMassageFilled = currentStepIndex >= 2;
    const isTermineFilled = currentStepIndex >= 3;

    const isDuo = selectedItem?.booking?.therapists?.length == 2;
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [anchorElStatus, setAnchorElStatus] = useState(null);
    const [pendingStatusChange, setPendingStatusChange] = useState({ item: null, newStatus: null, justification: null });
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const notify = useNotifications();
    const { auth } = useAuth();
    const isAdmin = auth?.roles?.some(role => role.name === "ROLE_ADMIN");
    const [bookingToDuplicate, setBookingToDuplicate] = useState(false);
    const [cancelChoicePhase, setCancelChoicePhase] = useState(false);
    const [cancelMessage, setCancelMessage] = useState("");
    const [cancelSuccessMessage, setCancelSuccessMessage] = useState("");
    const [showCancelConfirm, setShowCancelConfirm] = useState(false);
    const [showAdminCancelModal, setShowAdminCancelModal] = useState(false);
    const [bookingForAdminCancel, setBookingForAdminCancel] = useState(null);
    const [detailsModalIsOpenFicheHotel, setDetailsModalIsOpenFicheHotel] = useState(false);
    const [selectedHotel, setSelectedHotel] = useState(false);
    const [detailsModalIsOpenFiche, setDetailsModalIsOpenFiche] = useState(false);
    const [slotStatus, setSlotStatus] = useState("-");
    const [travelTime, setTravelTime] = useState("-");
    const [ficheFormDataHotel, setFicheFormDataHotel] = useState({
        id: '',
        hotel_id: '',
        tenue_vestimentaire: '',
        parking: '',
        ou_se_diriger: '',
        comment_et_ou_sinstaller: '',
        materiel_a_prendre: '',
        materiel_sur_place: '',
        prestations_que_lon_peut_fournir: '',
        infos_complementaires: '',
    });
    const [ficheFormData, setFicheFormData] = useState({
        id: '',
        user_id: '',
        parking: '',
        maison_ou_immeuble: '',
        infos_logistiques: '',
        tensions_particulieres: '',
        pression_ideale: '',
        huile_preferee: '',
        type_musique: '',
        problemes_physique: '',
        parties_preferees: '',
        parties_a_ne_pas_masser: '',
        se_fait_masser_nu: '',
        mauvaise_hygiene: '',
        remarque_deplacee: '',
        age: '',
        type_profession: '',
        source: '',
        classe_sociale: '',
        parking_on: '',
        infos_logistiques_on: '',
        maison_ou_immeuble_on: '',
        problemes_physique_on: '',
        couleur_on: '',
        forme_on: '',
        cuticules_on: '',
        ongle_on: '',
        age_on: '',
        type_on: '',
        entendu_on: '',
        classe_on: '',
        info_on: '',
        info_complementaires: '',
    });
    const [activeTabForm, setActiveTabForm] = useState('form');
    const [deleteWarning, setDeleteWarning] = useState("");

    const getDeleteWarning = (item) => {

        if (item.status === "CANCELED" || item.status === "COMPLETED") {
            return "";
        }
  
        if (item.offline_payment === true) {
          return t("dashboard:menu.offlinePaymentDeleteWarning");
        }
      
        if (item.status === "FAILED_PAYMENT") {
          return t("dashboard:menu.failedPaymentDeleteWarning");
        }
      
        if (item.transactions?.length > 0 && item.transactions[0]?.succeeded_at) {
          return t("dashboard:menu.criticalDeleteWarning");
        }
      
        return "";
      };

    const canAdminFlexibleCancel = (booking) => Boolean(
        isAdmin
        && booking
        && !['CANCELED', 'DECLINED', 'COMPLETED'].includes(booking.status)
    );

    const openAdminFlexibleCancellation = (booking) => {
        setBookingForAdminCancel(booking);
        setShowAdminCancelModal(true);
    };

    const closeAdminFlexibleCancellation = () => {
        setShowAdminCancelModal(false);
        setBookingForAdminCancel(null);
    };

    const handleAdminFlexibleCancellationSuccess = async () => {
        if (fetchBookings) {
            await fetchBookings();
        }
    };
      

    const handleTabClick = (tabName) => {
        setActiveTabForm(tabName);
    };

    const handleChangeFicheHotel = async (e) => {

        setFicheFormDataHotel({
            ...ficheFormDataHotel,
            [e.target.name]: e.target.value,
        });

    };

    const closeFichesModalHotel = () => {
        setSelectedHotel(false);
        setFicheFormDataHotel({
            id: '',
            hotel_id: '',
            tenue_vestimentaire: '',
            parking: '',
            ou_se_diriger: '',
            comment_et_ou_sinstaller: '',
            materiel_a_prendre: '',
            materiel_sur_place: '',
            prestations_que_lon_peut_fournir: '',
            infos_complementaires: '',
        });
        setDetailsModalIsOpenFicheHotel(false);
    };
    const openFicheModalHotel = (booking) => {
        setSelectedHotel(true);
        setFicheFormDataHotel({
            id: booking.hotel.fiche_hotel[0]?.id,
            hotel_id: booking.hotel.fiche_hotel[0]?.hotel_id,
            tenue_vestimentaire: booking.hotel.fiche_hotel[0]?.tenue_vestimentaire,
            parking: booking.hotel.fiche_hotel[0]?.parking,
            ou_se_diriger: booking.hotel.fiche_hotel[0]?.ou_se_diriger,
            comment_et_ou_sinstaller: booking.hotel.fiche_hotel[0]?.comment_et_ou_sinstaller,
            materiel_a_prendre: booking.hotel.fiche_hotel[0]?.materiel_a_prendre,
            materiel_sur_place: booking.hotel.fiche_hotel[0]?.materiel_sur_place,
            prestations_que_lon_peut_fournir: booking.hotel.fiche_hotel[0]?.prestations_que_lon_peut_fournir,
            infos_complementaires: booking.hotel.fiche_hotel[0]?.infos_complementaires,
        });
        setDetailsModalIsOpenFicheHotel(true);
    };
    const handleSubmitFicheHotel = async (e) => {
        e.preventDefault();

        try {
            const response = await (ficheFormDataHotel.id ? FicheHotelService.update(ficheFormDataHotel.id, { ...ficheFormDataHotel, hotel_id: selectedItem.booking.hotel.id }, api) : FicheHotelService.store({ ...ficheFormDataHotel, hotel_id: selectedItem.booking.hotel.id }, api));
            if (response.data) {
                closeFichesModalHotel();
                if (fetchBookings) {
                    fetchBookings();
                }
            }
        } catch (e) {
            // errors handled in interceptor
        }
    };

    const handleSubmitFiche = async (e) => {
        e.preventDefault();

        try {
            const response = await (ficheFormData.id ? FicheClientService.update(ficheFormData.id, { ...ficheFormData, user_id: selectedItem.booking.client.id }, api) : FicheClientService.store({ ...ficheFormData, user_id: selectedItem.booking.client.id }, api));
            if (response.data) {
                closeFichesModal();
                if (fetchBookings) {
                    fetchBookings();
                }
            }
        } catch (e) {
            // errors handled in interceptor
        }
    };

    const openFicheModal = (booking) => {
        setFicheFormData(
            {
                id: booking.client.fiche_client[0]?.id,
                user_id: booking.client.fiche_client[0]?.user_id,
                parking: booking.client.fiche_client[0]?.parking,
                maison_ou_immeuble: booking.client.fiche_client[0]?.maison_ou_immeuble,
                infos_logistiques: booking.client.fiche_client[0]?.infos_logistiques,
                tensions_particulieres: booking.client.fiche_client[0]?.tensions_particulieres,
                pression_ideale: booking.client.fiche_client[0]?.pression_ideale,
                huile_preferee: booking.client.fiche_client[0]?.huile_preferee,
                type_musique: booking.client.fiche_client[0]?.type_musique,
                problemes_physique: booking.client.fiche_client[0]?.problemes_physique,
                parties_preferees: booking.client.fiche_client[0]?.parties_preferees,
                parties_a_ne_pas_masser: booking.client.fiche_client[0]?.parties_a_ne_pas_masser,
                se_fait_masser_nu: booking.client.fiche_client[0]?.se_fait_masser_nu,
                mauvaise_hygiene: booking.client.fiche_client[0]?.mauvaise_hygiene,
                remarque_deplacee: booking.client.fiche_client[0]?.remarque_deplacee,
                age: booking.client.fiche_client[0]?.age,
                type_profession: booking.client.fiche_client[0]?.type_profession,
                source: booking.client.fiche_client[0]?.source,
                classe_sociale: booking.client.fiche_client[0]?.classe_sociale,
                parking_on: booking.client.fiche_client[0]?.parking_on,
                infos_logistiques_on: booking.client.fiche_client[0]?.infos_logistiques_on,
                maison_ou_immeuble_on: booking.client.fiche_client[0]?.maison_ou_immeuble_on,
                problemes_physique_on: booking.client.fiche_client[0]?.problemes_physique_on,
                couleur_on: booking.client.fiche_client[0]?.couleur_on,
                forme_on: booking.client.fiche_client[0]?.forme_on,
                cuticules_on: booking.client.fiche_client[0]?.cuticules_on,
                ongle_on: booking.client.fiche_client[0]?.ongle_on,
                age_on: booking.client.fiche_client[0]?.age_on,
                type_on: booking.client.fiche_client[0]?.type_on,
                entendu_on: booking.client.fiche_client[0]?.entendu_on,
                classe_on: booking.client.fiche_client[0]?.classe_on,
                info_on: booking.client.fiche_client[0]?.info_on,
                info_complementaires: booking.client.fiche_client[0]?.info_complementaires,
            }
        )
        setDetailsModalIsOpenFiche(true);

    };

    const closeFichesModal = () => {
        setFicheFormData(
            {
                id: '',
                user_id: '',
                parking: '',
                maison_ou_immeuble: '',
                infos_logistiques: '',
                tensions_particulieres: '',
                pression_ideale: '',
                huile_preferee: '',
                type_musique: '',
                problemes_physique: '',
                parties_preferees: '',
                parties_a_ne_pas_masser: '',
                se_fait_masser_nu: '',
                mauvaise_hygiene: '',
                remarque_deplacee: '',
                age: '',
                type_profession: '',
                source: '',
                classe_sociale: '',
                parking_on: '',
                infos_logistiques_on: '',
                maison_ou_immeuble_on: '',
                problemes_physique_on: '',
                couleur_on: '',
                forme_on: '',
                cuticules_on: '',
                ongle_on: '',
                age_on: '',
                type_on: '',
                entendu_on: '',
                classe_on: '',
                info_on: '',
                info_complementaires: '',
            }
        )
        setDetailsModalIsOpenFiche(false);
    };
    const handleChangeFiche = (e) => {
        setFicheFormData({
            ...ficheFormData,
            [e.target.name]: e.target.value,
        });
    };


    const showCancelModal = (booking) => {
        let message = "";
        if (booking?.offline_payment) {
            message = t('dashboard:confirm_cancel_offline');
            setCancelChoicePhase(false);
        } else {
            const now = new Date();
            const start = new Date(booking.start_before);
            const diffInHours = (start - now) / (1000 * 60 * 60);

            if (diffInHours < 24) {
                message = t('dashboard:cancel_w_24');
                setCancelChoicePhase(false);
            } else if (diffInHours >= 24 && diffInHours <= 120) {
                message = t('dashboard:cancel_promo_notice');
                setCancelChoicePhase(true);
            } else {
                message = t('dashboard:cancel_refund_notice');
                setCancelChoicePhase(false);
            }
        }

        setCancelMessage(message);
        setCancelSuccessMessage("");
        setShowCancelConfirm(true);
    };

    const handleCancelBooking = async (option) => {
        if (!option) option = 'FULL_REFUND';

        try {
            const response = await BookingService.cancel(
                selectedItem.booking.id,
                api,
                { params: { option } }
            );
            if (fetchBookings) {
                fetchBookings();
            }
            setShowCancelConfirm(false);

            const { refundType, promoCode } = response.data || {};
            if (refundType === 'FULL_REFUND') {
                setCancelSuccessMessage(t('cancel_message_f'));
            } else if (refundType === 'FLATT_OFF') {
                setCancelSuccessMessage(t('cancel_message_f'))
            } else {
                setCancelSuccessMessage(t('cancel_message_f'))
            }

            setShowCancelConfirm(true);

        } catch (err) {

        }
    };

    const handleDelete = async () => {
        try {
            const response = await BookingService.cancelDelete(selectedItem.booking.id, api);
            if (fetchBookings) {
                fetchBookings();
            }
        } catch (error) {

        }
    };
    const handleClickStatus = (event) => {
        event.stopPropagation();
        setAnchorElStatus(event.currentTarget);
    };
    const handleClickPDF = async (booking) => {
        const blob = await BookingService.downloadReceipt(booking.id, api);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${t('dashboard:menu.facture')} ${booking.id}.pdf`;
        link.click();
    };
    const sendPayLink = async () => {
        try {
            const response = await BookingService.resendPaymentLink(selectedItem.booking.id, api);
            notify.success(response?.message || t('dashboard:link'));
        } catch (error) {
            notify.error(error?.response?.data?.message || "Impossible de renvoyer le lien de paiement.");
        }
    };

    const handleDeleteConfirmation = () => {
        handleDelete();
        setOpenDeleteDialog(false);
        setDeleteWarning("");
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setAnchorElStatus(null);

    };

    const handleClose = () => {
        setAnchorEl(null);
        setAnchorElStatus(null);

    };
    const handleCloseDialog = () => {
        setOpenDeleteDialog(false);
        setDeleteWarning("");
    };
    const handleStatusChange = async () => {
        try {
            console.log({ pendingStatusChange })
            await BookingService.update(pendingStatusChange.item.id, { status: pendingStatusChange.newStatus, justification: pendingStatusChange.justification }, api);
            if (fetchBookings) {
                fetchBookings();
            }
            handleClose();
            setConfirmDialogOpen(false);
            setPendingStatusChange({ item: null, newStatus: null, justification: null });
        } catch (err) {
            console.error(err);

        }
    }

    const fetchCalendarData = async () => {
        try {
            const params = {
                date: `${new Date(selectedItem.booking.start_before).toLocaleDateString("en-CA").split("T")[0]}`,
                with: "calendars_managements_slots.slot",
                therapist_id: `${selectedItem.therapist.id}`,
            };

            const response = await CalendarManagementService.index(params, api);
            const result = getCurrentZurichSlotStatus(response[0]?.calendars_managements_slots);
            const resultTravel = response[0]?.calendars_managements_slots.filter(item => item.booking_id === selectedItem.booking.id && item.status === 'TRAVEL');

            console.log({ result })
            console.log({ response })
            console.log({ resultTravel })
            if (resultTravel.length > 0) {
                const travelDuration = getTravelDuration(resultTravel[0]);
                setTravelTime(travelDuration)
                console.log(travelDuration);
            }
            setSlotStatus(result)
            return result;
        } catch (error) {
            console.error(
                "Erreur lors de la récupération des données du calendrier :",
                error
            );
            throw error;
        }
    };
    useEffect(() => {
        fetchCalendarData();
    }, [selectedItem.booking.start_before]);

    useEffect(() => {
        const loadData = async () => {
            const promo = selectedItem?.booking?.promocode;
    
            if (promo && promo.trim() !== '') {
                const response = await PromotionService.index(
                    { code: promo },
                    api
                );
                setPromodetails(response);
            } else {
                setPromodetails(null);
            }
        };
    
        loadData();
    }, [selectedItem?.booking]);    

    const formatPromo = (promo) => {
        if (!promo) return "N/A";
      
        if (promo.type === "FREE") return t("promo.free");
      
        let unit = "";
        let prefix = "-";
      
        if (promo.type === "DURATION") {
          unit = " min";
          prefix = "";
        } 
        else if (promo.type === "FLAT_OFF") unit = " CHF";
        else unit = "%";
      
        return `${prefix}${promo.amount}${unit} -`;
    };

    function getTravelDuration(slot) {
        if (!slot || slot.status !== "TRAVEL") return null;

        const [sh, sm] = slot.slot.start_time.split(":").map(Number);
        const [eh, em] = slot.slot.end_time.split(":").map(Number);

        const start = sh * 60 + sm;
        const end = eh * 60 + em;

        return `${t('traveld')}: ${end - start} min`;
    }

    function getCurrentZurichSlotStatus(slots) {
        // time in Zurich
        const zurichTime = new Date().toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "Europe/Zurich"
        });

        const [nowH, nowM] = zurichTime.split(":").map(Number);
        const nowMinutes = nowH * 60 + nowM;

        // start_time <= now <= end_time
        const matchingSlot = slots.find(s => {
            const [sh, sm] = s.slot.start_time.split(":").map(Number);
            const [eh, em] = s.slot.end_time.split(":").map(Number);
            const start = sh * 60 + sm;
            const end = eh * 60 + em;

            return nowMinutes >= start && nowMinutes <= end;
        });

        if (!matchingSlot) {
            return `Status: N/A`;
        }

        return `Status: ${t(`statusPro.${matchingSlot.status}`)} ${matchingSlot.booking_id && matchingSlot.booking_id !== selectedItem.booking.id  ? `${t('for')} ${matchingSlot.booking_id}` : '' }`;
    }



    console.log({ selectedItem })
    return (
        <div className={styles.listItemWithImage} style={{ overflow: 'hidden', overflowY: 'scroll', scrollbarWidth: 'none' }}>
            <div className={styles.title} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{t('command.command')} / {selectedItem.booking.id}
                {isDuo && <span className="map_duo-tag">DUO</span>}
            </div>
            <div className="tabs">
                <div className="tab-group">
                    <div
                        className={`label1 ${activeTab === "details" ? "active" : ""}`}
                        onClick={() => setActiveTab("details")}
                    >
                        <div className="state-layer">
                            <div className="tab-contents">
                                <div className="label2">{t('command.details')}</div>
                                {activeTab === "details" && (
                                    <div className="indicator">
                                        <div className="shape"></div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div
                        className={`tab22 ${activeTab === "client" ? "active" : ""}`}
                        onClick={() => setActiveTab("client")}
                    >
                        <div className="state-layer">
                            <div className="tab-contents">
                                <div className="label2">{selectedItem.booking.client?.roles?.some(role => role.name === 'ROLE_CLIENT') ? 'Client' : 'Hotel'}</div>
                                {activeTab === "client" && (
                                    <div className="indicator">
                                        <div className="shape"></div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div
                        className={`styles.tab22 ${activeTab === "historique" ? "active" : ""}`}
                        onClick={() => setActiveTab("historique")}
                    >
                        <div className="state-layer">
                            <div className="tab-contents">
                                <div className="label2">{t('command.historic')}</div>
                                {activeTab === "historique" && (
                                    <div className="indicator">
                                        <div className="shape"></div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div style={{ margin: "auto" }}>
                        <IconButton
                            aria-label="more"
                            aria-controls={Boolean(anchorEl) ? "action-menu" : undefined}
                            aria-haspopup="true"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleClick(e);
                            }}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            id="action-menu"
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation() }}
                        >
                            <MenuList style={{ minWidth: 150 }}>
                                {selectedItem.booking.status === 'COMPLETED' && selectedItem.booking.transactions?.length > 0 && selectedItem.booking.transactions[0]?.succeeded_at && (
                                    <MenuItem
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleClickPDF(selectedItem.booking);
                                        }}
                                    >
                                        <ListItemIcon>
                                            <DownloadForOfflineIcon style={{ color: "#1976d2" }} />
                                        </ListItemIcon>
                                        <ListItemText>{t('dashboard:menu.downloadBill')}</ListItemText>
                                    </MenuItem>

                                )}

                                <MenuItem
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleClickStatus(e);
                                    }}
                                >
                                    <ListItemIcon>
                                        <EditIcon style={{ color: "#1976d2" }} />
                                    </ListItemIcon>
                                    <ListItemText>{t('dashboard:modal.bookingDetails.labels.status')}</ListItemText>
                                    <ListItemIcon>
                                        <ChevronRightIcon style={{ color: "#1976d2" }} />
                                    </ListItemIcon>

                                    <Menu
                                        anchorEl={anchorElStatus}
                                        open={Boolean(anchorElStatus)}
                                        onClose={handleClose}
                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                    >
                                        <MenuList style={{ minWidth: 150 }}>
                                            <MenuItem disabled>
                                                <ListItemText primary="Current Status" secondary={t(`status.${selectedItem.booking.status}`)} />
                                            </MenuItem>
                                            <Divider />
                                            {Object.entries({
                                                PENDING_ACKNOWLEDGEMENT: 'PENDING ACKNOWLEDGEMENT',
                                                ACKNOWLEDGED: 'ACKNOWLEDGED',
                                                IN_TRANSIT: 'IN TRANSIT',
                                                // STARTED: 'STARTED',
                                                REACHED: 'REACHED',
                                                COMPLETED: 'COMPLETED',
                                                DECLINED: 'DECLINED',
                                                FAILED: 'FAILED',
                                            })
                                                .filter(([statusKey]) => statusKey !== selectedItem.booking.status)
                                                .map(([statusKey, statusLabel]) => (
                                                    <MenuItem
                                                        key={statusKey}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setConfirmDialogOpen(true);
                                                            setPendingStatusChange({ item: selectedItem.booking, newStatus: statusKey, justification: selectedItem.booking.justification });
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary={t(`status.${statusKey}`)}
                                                        />
                                                    </MenuItem>
                                                ))}
                                        </MenuList>
                                    </Menu>
                                </MenuItem>
                                <MenuItem
                                    onClick={e => {
                                        e.stopPropagation();
                                        handleClose();
                                        setEditModalOpen(true);
                                    }}
                                >
                                    <ListItemIcon>
                                        <EditIcon style={{ color: "#1976d2" }} />
                                    </ListItemIcon>
                                    <ListItemText>{t('dashboard:edits')}</ListItemText>
                                </MenuItem>
                                {canResendPaymentLink(selectedItem.booking) && (<MenuItem
                                    onClick={e => {
                                        e.stopPropagation();
                                        sendPayLink(selectedItem.booking);
                                        handleClose();
                                    }}
                                >
                                    <ListItemIcon>
                                        <EditIcon style={{ color: "#1976d2" }} />
                                    </ListItemIcon>
                                    <ListItemText>{t('dashboard:link')}</ListItemText>
                                </MenuItem>
                                )}
                                {selectedItem.booking.hotel_id != null && (
                                    <MenuItem
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleClose();
                                            openFicheModalHotel(selectedItem.booking);
                                        }}
                                    >
                                        <ListItemIcon>
                                            <EditIcon style={{ color: "#1976d2" }} />
                                        </ListItemIcon>
                                        <ListItemText>{t('dashboard:menu.showHotelQuestionnaire')}</ListItemText>
                                    </MenuItem>
                                )}

                                <MenuItem
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleClose();
                                        openFicheModal(selectedItem.booking);
                                    }}
                                >
                                    <ListItemIcon>
                                        <EditIcon style={{ color: "#1976d2" }} />
                                    </ListItemIcon>
                                    <ListItemText>{t('dashboard:menu.showClientQuestionnaire')}</ListItemText>
                                </MenuItem>
                                <MenuItem
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleClose();
                                        setBookingToDuplicate(true);
                                    }}
                                >
                                    <ListItemIcon>
                                        <FileCopyIcon style={{ color: "#1976d2" }} />
                                    </ListItemIcon>
                                    <ListItemText>{t('dashboard:duplicate')}</ListItemText>
                                </MenuItem>
                                {!(selectedItem.booking.status === 'CANCELED' || selectedItem.booking.status === 'DECLINED' || selectedItem.booking.status === 'COMPLETED') && (
                                    <MenuItem
                                        style={{ color: "red" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleClose();
                                            showCancelModal(selectedItem.booking);
                                        }}
                                    >
                                        <ListItemIcon>
                                            <CancelIcon style={{ color: "red" }} />
                                        </ListItemIcon>
                                        <ListItemText>{t('dashboard:cancel')}</ListItemText>
                                    </MenuItem>
                                )}
                                {canAdminFlexibleCancel(selectedItem.booking) && (
                                    <MenuItem
                                        style={{ color: "#9a5a00" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleClose();
                                            openAdminFlexibleCancellation(selectedItem.booking);
                                        }}
                                    >
                                        <ListItemIcon>
                                            <CancelIcon style={{ color: "#9a5a00" }} />
                                        </ListItemIcon>
                                        <ListItemText>{t('dashboard:adminCancel.flexibleAction')}</ListItemText>
                                    </MenuItem>
                                )}
                                <MenuItem
                                    style={{ color: "red" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenDeleteDialog(true);
                                        setDeleteWarning(getDeleteWarning(selectedItem.booking));
                                    }}
                                >
                                    <ListItemIcon>
                                        <DeleteIcon style={{ color: "red" }} />
                                    </ListItemIcon>
                                    <ListItemText>{t('dashboard:menu.delete')}</ListItemText>
                                </MenuItem>
                                <Dialog open={openDeleteDialog} onClose={handleCloseDialog}>
                                    <DialogTitle>{t('dashboard:menu.Cdelete')}</DialogTitle>
                                    {deleteWarning && (
                                        <p style={{
                                            marginTop: "10px",
                                            textAlign: "center",
                                            color: deleteWarning.includes("!") ? "red" : "orange",
                                            fontWeight: "bold"
                                        }}>
                                            {deleteWarning}
                                        </p>
                                    )}
                                    <DialogContent>
                                        {t('dashboard:menu.confirmDelete')}
                                        <Button onClick={handleCloseDialog} color="primary">
                                            {t('dashboard:close_button')}
                                        </Button>
                                        <Button onClick={handleDeleteConfirmation} style={{ color: "red" }}>
                                            {t('dashboard:menu.delete')}
                                        </Button>
                                    </DialogContent>
                                </Dialog>
                            </MenuList>
                        </Menu>
                    </div>
                    {/*  Dialog  */}
                    <Dialog
                        open={confirmDialogOpen}
                        onClose={() => setConfirmDialogOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {t('dashboard:confirmation')}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {t('dashboard:change')} <strong>{t(`status.${pendingStatusChange.item?.status}`)}</strong> {t('dashboard:a')} <strong>{t(`status.${pendingStatusChange.newStatus}`)}</strong>?
                            </DialogContentText>
                            {(pendingStatusChange.newStatus === "FAILED" || pendingStatusChange.newStatus === "DECLINED") && (
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="justification"
                                    label="Justification"
                                    type="text"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={pendingStatusChange.justification || ''}
                                    onChange={(e) =>
                                        setPendingStatusChange((prev) => ({
                                            ...prev,
                                            justification: e.target.value,
                                        }))
                                    }
                                />
                            )}

                        </DialogContent>
                        <Button onClick={() => setConfirmDialogOpen(false)} color="primary">
                            {t('dashboard:close_button')}
                        </Button>
                        <Button
                            onClick={handleStatusChange}
                            color="primary"
                            autoFocus
                            variant="contained"
                        >
                            {t('dashboard:confirm')}
                        </Button>
                    </Dialog>
                    {/* edit call */}
                    {editModalOpen && (
                        <EditBookingModal
                            open={editModalOpen}
                            onClose={() => {
                                setEditModalOpen(false);
                            }}
                            booking={selectedItem.booking}
                            onSuccess={fetchBookings}
                            api={api}
                            key={selectedItem.booking?.id}
                        />
                    )}
                    {/* duplicate */}
                    {bookingToDuplicate && (
                        <CreateTaskModal
                            api={api}
                            onSuccess={() => {
                                fetchBookings();
                                setBookingToDuplicate(false);
                            }}
                            bookingToDuplicate={selectedItem.booking}
                            onClose={() => {
                                setBookingToDuplicate(false);
                            }}
                            key={selectedItem.booking?.id}
                        />
                    )}
                    <AdminFlexibleCancellationModal
                        isOpen={showAdminCancelModal}
                        booking={bookingForAdminCancel}
                        api={api}
                        onClose={closeAdminFlexibleCancellation}
                        onSuccess={handleAdminFlexibleCancellationSuccess}
                    />
                    {/* cancel */}
                    <Modal
                        isOpen={showCancelConfirm}
                        onRequestClose={() => setShowCancelConfirm(false)}
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                transform: 'translate(-50%, -50%)',
                                width: '90%',
                                maxWidth: '440px',
                                height: 'auto',
                                maxHeight: '90vh',
                                overflowY: 'auto',
                                padding: '30px',
                                borderRadius: '12px',
                                textAlign: 'center',
                            }
                        }}
                    >
                        {!cancelSuccessMessage ? (
                            <>
                                <h2>{t('dashboard:cancel_title')}</h2>
                                <p style={{ marginTop: '20px' }}>{cancelMessage}</p>
                                <a
                                    href="https://flyspa.ch/conditions-annulation/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ fontSize: '14px', textDecoration: 'underline', display: 'block', marginTop: '10px' }}
                                >
                                    {t('dashboard:cancel_condition')}
                                </a>

                                {cancelChoicePhase ? (
                                    <>
                                        <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "24px" }}>
                                            <ThemeProvider theme={theme}>
                                                <Button
                                                    onClick={() => handleCancelBooking('FULL_REFUND')}
                                                    variant="contained"
                                                    color="dark_yellow"
                                                    sx={{
                                                        textTransform: 'none',
                                                        borderRadius: '15px',
                                                        width: '100%',
                                                        minWidth: '180px',
                                                        minHeight: '50px',
                                                    }}
                                                >
                                                    {t('dashboard:remboursement')}
                                                </Button>
                                                <Button
                                                    onClick={() => handleCancelBooking('FLATT_OFF')}
                                                    variant="contained"
                                                    color="dark_yellow"
                                                    sx={{
                                                        textTransform: 'none',
                                                        borderRadius: '15px',
                                                        width: '100%',
                                                        minWidth: '180px',
                                                        minHeight: '50px',
                                                    }}
                                                >
                                                    {t('dashboard:avoir')}
                                                </Button>
                                            </ThemeProvider>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "24px" }}>
                                            <ThemeProvider theme={theme}>
                                                <Button
                                                    onClick={() => setShowCancelConfirm(false)}
                                                    variant="contained"
                                                    color="dark_grey"
                                                    sx={{
                                                        textTransform: 'none',
                                                        borderRadius: '15px',
                                                        width: '100%',
                                                        minWidth: '180px',
                                                        minHeight: '50px',
                                                    }}
                                                >
                                                    {t('dashboard:cancel_button')}
                                                </Button>
                                            </ThemeProvider>
                                        </div>
                                    </>
                                ) : (
                                    <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginTop: "24px" }}>
                                        <ThemeProvider theme={theme}>
                                            <Button
                                                onClick={() => handleCancelBooking('FULL_REFUND')}
                                                variant="contained"
                                                color="dark_yellow"
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '15px',
                                                    width: '100%',
                                                    minWidth: '180px',
                                                    minHeight: '50px',
                                                }}
                                            >
                                                {t('dashboard:continue_button')}
                                            </Button>
                                            <Button
                                                onClick={() => setShowCancelConfirm(false)}
                                                variant="contained"
                                                color="dark_grey"
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '15px',
                                                    width: '100%',
                                                    minWidth: '180px',
                                                    minHeight: '50px',
                                                }}
                                            >
                                                {t('dashboard:close_button')}
                                            </Button>
                                        </ThemeProvider>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <h2>{t('cancel_message')}</h2>
                                <p style={{ marginTop: '20px' }}>{cancelSuccessMessage}</p>
                                <button
                                    onClick={() => setShowCancelConfirm(false)}
                                    style={{
                                        marginTop: "24px",
                                        padding: "12px 28px",
                                        backgroundColor: "#393d44",
                                        color: "#faef9b",
                                        border: "none",
                                        borderRadius: "8px",
                                        cursor: "pointer"
                                    }}
                                >
                                    {t('close_button')}
                                </button>
                            </>
                        )}
                    </Modal>
                    {/* hotel fiche */}
                    <Modal
                        isOpen={detailsModalIsOpenFicheHotel}
                        onRequestClose={closeFichesModalHotel}
                        style={customStyles}
                    >
                        <button className="close-button" onClick={closeFichesModalHotel}>
                            <span className="close-icon">✖</span>
                        </button>
                        {selectedHotel && (
                            <div className="form-inscription mrgBottom">
                                <h2>{t('dashboard:modal.hotelQuestionnaire.title')}: {selectedItem.booking.hotel?.name}</h2><br />
                                <form onSubmit={handleSubmitFicheHotel}>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.parking')}</label>
                                        <input type="text" name="parking" value={ficheFormDataHotel.parking} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.dressCode')}</label>
                                        <input type="text" name="tenue_vestimentaire" value={ficheFormDataHotel.tenue_vestimentaire} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.whereToGo')}</label>
                                        <input type="text" name="ou_se_diriger" value={ficheFormDataHotel.ou_se_diriger} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.howAndWhereToSettle')}</label>
                                        <input type="text" name="comment_et_ou_sinstaller" value={ficheFormDataHotel.comment_et_ou_sinstaller} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.materialToBring')}</label>
                                        <input type="text" name="materiel_a_prendre" value={ficheFormDataHotel.materiel_a_prendre} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.materialOnSite')}</label>
                                        <input type="text" name="materiel_sur_place" value={ficheFormDataHotel.materiel_sur_place} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.servicesProvided')}</label>
                                        <input type="text" name="prestations_que_lon_peut_fournir" value={ficheFormDataHotel.prestations_que_lon_peut_fournir} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <div className="input-hotel-container">
                                        <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.additionalInfo')}</label>
                                        <input type="text" name="infos_complementaires" value={ficheFormDataHotel.infos_complementaires} onChange={handleChangeFicheHotel} />
                                    </div>
                                    <button type="submit" className="btn-submit">
                                        {ficheFormDataHotel.id ? t('dashboard:modal.hotelQuestionnaire.buttons.update') : t('dashboard:modal.hotelQuestionnaire.buttons.save')}
                                    </button>
                                </form>
                            </div>
                        )}
                    </Modal>
                    {/* fiche client */}
                    <Modal
                        isOpen={detailsModalIsOpenFiche}
                        onRequestClose={closeFichesModal}
                        style={customStyles}
                    >
                        <button className="close-button" onClick={closeFichesModal}>
                            <span className="close-icon">✖</span>
                        </button>

                        {selectedItem.booking && (
                            <div className="form-inscription mrgBottom">
                                <div className="tabqa">
                                    <button className={`button btn-tabs tab ${activeTab === 'form' ? 'active' : ''}`} onClick={() => handleTabClick('form')}>
                                        {t('dashboard:modal.clientQuestionnaire.tabs.massages')}
                                    </button>
                                    <button
                                        className={`button btn-tabs tab ${activeTab === 'info' ? 'active' : ''}`} onClick={() => handleTabClick('info')}>
                                        {t('dashboard:modal.clientQuestionnaire.tabs.nailCare')}
                                    </button>
                                </div>

                                <div className="tab-content">
                                    {activeTabForm === 'form' && (
                                        <div className="form-section">
                                            <h2>{t('dashboard:modal.clientQuestionnaire.title')} {selectedItem.booking.client?.extra?.full_name}</h2>
                                            <br />
                                            <br />
                                            <form onSubmit={handleSubmitFiche}>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.parking')}</label>
                                                    <input type="text" name="parking" value={ficheFormData.parking} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.houseOrBuilding')}</label>
                                                    <input type="text" name="maison_ou_immeuble" value={ficheFormData.maison_ou_immeuble} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.logisticsInfo')}</label>
                                                    <input type="text" name="infos_logistiques" value={ficheFormData.infos_logistiques} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.specificTensions')}</label>
                                                    <input type="text" name="tensions_particulieres" value={ficheFormData.tensions_particulieres} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.idealPressure')}</label>
                                                    <input type="text" name="pression_ideale" value={ficheFormData.pression_ideale} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.preferredOil')}</label>
                                                    <input type="text" name="huile_preferee" value={ficheFormData.huile_preferee} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.musicType')}</label>
                                                    <input type="text" name="type_musique" value={ficheFormData.type_musique} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.healthIssues')}</label>
                                                    <input type="text" name="problemes_physique" value={ficheFormData.problemes_physique} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.preferredParts')}</label>
                                                    <input type="text" name="parties_preferees" value={ficheFormData.parties_preferees} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.partsToAvoid')}</label>
                                                    <input type="text" name="parties_a_ne_pas_masser" value={ficheFormData.parties_a_ne_pas_masser} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.nakedMassage')}</label>
                                                    <input type="text" name="se_fait_masser_nu" value={ficheFormData.se_fait_masser_nu} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.poorHygiene')}</label>
                                                    <input type="text" name="mauvaise_hygiene" value={ficheFormData.mauvaise_hygiene} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.inappropriateRemarks')}</label>
                                                    <input type="text" name="remarque_deplacee" value={ficheFormData.remarque_deplacee} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.approximateAge')}</label>
                                                    <input type="text" name="age" value={ficheFormData.age} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.profession')}</label>
                                                    <input type="text" name="type_profession" value={ficheFormData.type_profession} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.referralSource')}</label>
                                                    <input type="text" name="source" value={ficheFormData.source} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.socialClass')}</label>
                                                    <input type="text" name="classe_sociale" value={ficheFormData.classe_sociale} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.additionalInfo')}</label>
                                                    <input type="text" name="info_complementaires" value={ficheFormData.info_complementaires} onChange={handleChangeFiche} />
                                                </div>
                                                <button type="submit" className="btn-submit">
                                                    {ficheFormData.id ? 'Update' : 'Save'}
                                                </button>
                                            </form>
                                        </div>
                                    )}

                                    {activeTabForm === 'info' && (
                                        <div className="info-section">
                                            <h2>{t('dashboard:modal.clientQuestionnaire.title')} {selectedItem.booking.client.extra.full_name}</h2>
                                            <br />
                                            <br />
                                            <form onSubmit={handleSubmitFiche}>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.parking')}</label>
                                                    <input type="text" name="parking_on" value={ficheFormData.parking_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.logisticsInfo')}</label>
                                                    <input type="text" name="infos_logistiques_on" value={ficheFormData.infos_logistiques_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.houseOrBuilding')}</label>
                                                    <input type="text" name="maison_ou_immeuble_on" value={ficheFormData.maison_ou_immeuble_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.healthIssues')}</label>
                                                    <input type="text" name="problemes_physique_on" value={ficheFormData.problemes_physique_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.preferredColor')}</label>
                                                    <input type="text" name="couleur_on" value={ficheFormData.couleur_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.usualNailShape')}</label>
                                                    <input type="text" name="forme_on" value={ficheFormData.forme_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.cuticlePreference')}</label>
                                                    <input type="text" name="cuticules_on" value={ficheFormData.cuticules_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.nailType')}</label>
                                                    <input type="text" name="ongle_on" value={ficheFormData.ongle_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.approximateAge')}</label>
                                                    <input type="text" name="age_on" value={ficheFormData.age_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.profession')}</label>
                                                    <input type="text" name="type_on" value={ficheFormData.type_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.referralSource')}</label>
                                                    <input type="text" name="entendu_on" value={ficheFormData.entendu_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.clientQuestionnaire.labels.socialClass')}</label>
                                                    <input type="text" name="classe_on" value={ficheFormData.classe_on} onChange={handleChangeFiche} />
                                                </div>
                                                <div className="input-hotel-container">
                                                    <label className="input-hotel-label">{t('dashboard:modal.hotelQuestionnaire.labels.additionalInfo')}</label>
                                                    <input type="text" name="info_on" value={ficheFormData.info_on} onChange={handleChangeFiche} />
                                                </div>
                                                <button type="submit" className="btn-submit">
                                                    {ficheFormData.id ? 'Update' : 'Save'}
                                                </button>
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </Modal>
                </div>
            </div>

            {activeTab === 'details' && (
                <>
                    <div className={styles.title1}>
                        <p className={styles.statusSuccessful}>{t(`status.${selectedItem.booking.status}`)} {selectedItem.booking.refund_type ? `: ${t(`refundType.${selectedItem.booking.refund_type}`)}` : ''} </p>
                        {/* <p className={styles.statusSuccessful}>
                            <span className={styles.antiStressLp}>{t('command.orderID')}: </span>
                            <b>{selectedItem.booking.id}</b>
                        </p> */}
                        <p className={styles.statusSuccessful}>
                            <span className={styles.antiStressLp}>{t('command.duration')}: </span>
                            <b>{selectedItem.booking.duration} min</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            {/* <span className={styles.antiStressLp}>{t('command.startBefore')}: </span> */}
                            <b>{castDate(selectedItem.booking.start_before).replace(/:\d{2}$/, '')}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            {/* <span className={styles.antiStressLp}>{t('command.endBefore')}: </span> */}
                            <b>{castDate(new Date(new Date(selectedItem.booking.start_before).getTime() + selectedItem.booking.duration * 60 * 1000)).replace(/:\d{2}$/, '')}</b>
                        </p>
                        {/* <p className={styles.statusSuccessful}>{t('command.link')}:</p> */}
                        <p className={styles.statusSuccessful}>&nbsp;</p>
                        <p className={styles.statusSuccessful}>&nbsp;</p>
                        <p className={styles.statusSuccessful}>&nbsp;</p>
                        <p className={styles.statusSuccessful} onClick={fetchCalendarData}>
                            <span>{t('command.link')}: </span><br/>
                            <b className={styles.antiStressLp}>{slotStatus} </b><br/>
                            <b className={styles.antiStressLp}>{travelTime}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('dashboard:table.last_coordinate_update')}: </span>
                            <b className={styles.antiStressLp}>{castDate(selectedItem.therapist.last_coordinate_update).replace(/:\d{2}$/, '')}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('command.team')}: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking.address?.state || "-"}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span className={styles.antiStressLp}>{t('command.soin')}: </span>
                            <b>{selectedItem?.booking?.products?.map((product, index) => (
                                <span key={index}>
                                    {index > 0 && ", "}
                                    {i18nDisplay(product.category?.title)} {product.duration} min
                                </span>
                            ))}
                            </b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span className={styles.antiStressLp}>{`Pro: `}</span>
                            <b>{selectedItem.therapist.extra.full_name}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('command.task')}: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking.description}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>Justification: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking.justification}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>Message: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking.comment}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('dashboard:table.productprice')}: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking.products?.map(
                                (p) =>
                                    ` ${p.duration} min = ${p.price} CHF\n`
                            )}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('dashboard:table.prices')}: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking?.subtotal} CHF</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>Total: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking?.products?.reduce((total, p) => total + p.price, 0)} CHF</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>Code Promo: </span>
                            <b className={styles.antiStressLp}>{promodetails?.[0] ? formatPromo(promodetails[0]) : "" } {selectedItem.booking.promocode || 'N/A'}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('dashboard:modal.bookingDetails.labels.createdBy')} </span>
                            <b className={styles.antiStressLp}>{`${selectedItem.booking.creator?.extra?.full_name} - ${selectedItem.booking.creator?.roles?.map(
                                (role) =>
                                    `${asTitle(role.name)}\n`
                            )}`}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('dashboard:table.createdle')}: </span>
                            <b className={styles.antiStressLp}>{castDate(selectedItem.booking.created_at).replace(/:\d{2}$/, '')}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('dashboard:table.tags')}: </span>
                            <b className={styles.antiStressLp}>{selectedItem.booking.tags || 'N/A'}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{t('dashboard:modal.bookingDetails.labels.rating')} </span>
                            <b className={styles.antiStressLp}>{`${"⭐"} ${selectedItem.booking.extra.rating}/5`}</b>
                        </p>
                        {/* <p className={styles.statusSuccessful}>
                            <span>Total Time Taken:</span>
                            <b className={styles.antiStressLp}> {totalTime}</b>
                        </p>
                        <p className={styles.statusSuccessful}>
                            <span>{`Distance Traveled: `}</span>
                            <b className={styles.antiStressLp}>{distance}</b>
                        </p> */}
                    </div>
                    <div className={styles.groupParent}>
                        <div className={styles.rectangleParent}>
                            <div className={!isEnRouteFilled ? styles.groupChild : styles.groupChildFill} />
                            <div className={styles.enRouteParent}>
                                <div className={`${styles.enRoute} ${!isEnRouteFilled ? styles.fill : ''}`}>{t('command.road')}</div>
                                <span className={!isEnRouteFilled ? styles.vectorIcon1Fill : styles.vectorIcon1} />
                            </div>
                        </div>

                        {/* <div className={styles.rectangleGroup}>
                            <div className={!isPreparationFilled ? styles.groupItem : styles.groupItemFill} />
                            <div className={styles.prparationParent}>
                                <div className={`${styles.prparation} ${!isPreparationFilled ? styles.fill : ''}`}>{t('command.preparation')}</div>
                                <span className={!isPreparationFilled ? styles.vectorIcon2Fill : styles.vectorIcon2} />
                            </div>
                        </div> */}

                        <div className={styles.rectangleContainer}>
                            {/* <div className={!isMassageFilled ? styles.groupInner : styles.groupInnerFill} /> */}
                            <div className={!isPreparationFilled ? styles.groupInner : styles.groupInnerFill} />
                            <div className={styles.massageParent}>
                                <div className={`${styles.massage} ${!isPreparationFilled ? styles.fill : ''}`}>Massage</div>
                                {/* <div className={`${styles.massage} ${!isMassageFilled ? styles.fill : ''}`}>Massage</div>
                                <span className={!isMassageFilled ? styles.vectorIcon3Fill : styles.vectorIcon3} /> */}
                                <span className={!isPreparationFilled ? styles.vectorIcon3Fill : styles.vectorIcon3} />
                            </div>
                        </div>
                        <div className={styles.groupDiv}>
                            <div className={!isTermineFilled ? styles.groupInner : styles.groupInnerFill} />
                            <div className={styles.terminParent}>
                                <div className={`${styles.termin} ${!isTermineFilled ? styles.fill : ''}`}>{t('command.done')}</div>
                                <span className={!isTermineFilled ? styles.vectorIcon4Fill : styles.vectorIcon4} />
                            </div>
                        </div>
                        <span className={styles.frameChild} />
                    </div>
                </>
            )}
            {activeTab === 'client' && (
                <>
                    <div className={styles.generalInfo}>
                        {t('command.info')}
                    </div>
                    {selectedItem.booking.client?.roles?.some(role => role.name === 'ROLE_CLIENT') && (
                        <div className={styles.titleParentClient}>
                            <div className={styles.titleClient}>
                                <p className={styles.nameClient}>{t('command.name')}:</p>
                                <p className={styles.nameClient}>Contact:</p>
                                <p className={styles.nameClient}>{`Email: `}</p>
                                <p className={styles.nameClient}>{t('command.adress')}:</p>
                                <p className={styles.nameClient}>&nbsp;</p>
                            </div>
                            <div className={styles.title1Client}>
                                <p className={styles.nameClient}>
                                    <b>
                                        <span className={styles.spanClient}>{selectedItem.booking?.client?.extra?.full_name}</span>
                                    </b>
                                </p>
                                <p className={styles.nameClient}>
                                    <b>
                                        <a
                                            className={styles.spanClient}
                                            href={`tel:${selectedItem.booking?.client?.phone}`}
                                        >
                                            {selectedItem.booking?.client?.phone}
                                        </a>
                                    </b>
                                </p>
                                <p className={styles.nameClient}>
                                    <b>
                                        <a
                                            className={styles.spanClient}
                                            href={`mailto:${selectedItem.booking?.client?.email}`}
                                        >
                                            {selectedItem.booking?.client?.email}
                                        </a>
                                    </b>
                                </p>
                                <p className={styles.nameClient}>
                                    <b>
                                        <span className={styles.spanClient}>{addressFormat(selectedItem.booking?.client?.primary_address)}</span>
                                    </b>
                                </p>
                                <p className={styles.blankLine1Client}>&nbsp;</p>
                            </div>
                        </div>
                    )}
                    {selectedItem.booking.hotel && (
                        <div className={styles.titleParentClient}>
                            <div className={styles.titleClient}>
                                <p className={styles.nameClient}>Hotel:</p>
                                <p className={styles.nameClient}>Contact:</p>
                                <p className={styles.nameClient}>{t('command.adress')}:</p>
                                <p className={styles.nameClient}>&nbsp;</p>
                            </div>
                            <div className={styles.title1Client}>
                                <p className={styles.nameClient}>
                                    <b>
                                        <span className={styles.spanClient}>{selectedItem.booking?.hotel?.name}</span>
                                    </b>
                                </p>
                                <p className={styles.nameClient}>
                                    <b>
                                        <a
                                            className={styles.spanClient}
                                            href={`tel:${selectedItem.booking?.client?.phone}`}
                                        >
                                            {selectedItem.booking?.client?.phone}
                                        </a>
                                    </b>
                                </p>
                                <p className={styles.nameClient}>
                                    <b>
                                        <span className={styles.spanClient}>{addressFormat(selectedItem.booking?.hotel?.address)}</span>
                                    </b>
                                </p>
                                <p className={styles.blankLine1Client}>&nbsp;</p>
                            </div>
                        </div>
                    )}
                </>
            )}
            {activeTab === 'historique' && (
                <>
                    <div className={styles.generalInfo}>
                        {t('command.info')}
                    </div>
                    <div className={styles.frameParentHistory}>
                        {selectedItem.booking?.histories
                            ?.slice()
                            ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                            ?.filter(history =>
                                ['COMPLETED', 'ACKNOWLEDGED', 'REACHED', 'CANCELED', 'IN_TRANSIT', 'CREATED', 'FAILED']
                                    .includes(history.status?.toUpperCase())
                            )
                            ?.map((history, index) => {
                                const statusConfig = {
                                    COMPLETED: { color: '#45c343', label: 'command.completed' },
                                    CANCELED: { color: '#FF0000', label: 'status.CANCELED' },
                                    FAILED: { color: '#FF0000', label: 'status.FAILED' },
                                    ACKNOWLEDGED: { color: '#4d5ec4', label: 'command.accepted' },
                                    REACHED: { color: '#1c9dff', label: 'command.reached' },
                                    STARTED: { color: '#8fa9b9', label: 'command.started' },
                                    IN_TRANSIT: { color: '#393d44', label: 'command.road' },
                                    CREATED: { color: '#8fa9b9', label: 'command.created' },
                                };
                                const statusKey = history.status?.toUpperCase();
                                const { color, label } = statusConfig[statusKey];

                                return (
                                    <div key={index} className={styles.frameParent3History} style={{ justifyContent: 'center' }}>
                                        <div className={styles.groupWrapperHistory}>
                                            <div className={styles.ratingWrapperHistory}>
                                                <div className={styles.ratingHistory}>
                                                    <div className={styles.mayContainerHistory}>
                                                        <p className={styles.mayHistory}>
                                                            <b>{new Date(history.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}</b>
                                                        </p>
                                                        <p className={styles.pHistory}>
                                                            {new Date(history.created_at).toLocaleDateString('en-GB', { year: 'numeric' })} {new Date(history.created_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.groupContainerHistory}>
                                            <div className={styles.rectangleParentHistory}>
                                                <div className={styles.groupChildHistory} />
                                                <div className={styles.rating13History}>
                                                    <div className={styles.byApiApiHistory}>
                                                        {t('dashboard:by')} {history.creator?.extra?.full_name || 'System'}
                                                    </div>
                                                </div>
                                                <div className={styles.rating14History} style={{ backgroundColor: color, textAlign: 'center' }}>
                                                    <div className={styles.completedHistory}>{t(label)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </>
            )}
        </div>
    );
};

export default Commande;
